import { handleChunkLoadError } from '@hydra/utils/handleChunkLoadError';

export default ({
  path: '',
  async getComponent (nextState) {
    const {
      default: PricingContainer
    } = await import('./components/PricingContainer')
      .catch(handleChunkLoadError);
    return PricingContainer;
  },
  children: [
    {
      path: '/p/pricing',
      async getComponent (nextState) {
        const {
          default: PricingContainer
        } = await import('./components/PricingPage')
          .catch(handleChunkLoadError);
        return PricingContainer;
      },
      getData: ({ context: { props } }) => (props)
    },
    {
      path: '/user/plan',
      async getComponent (nextState) {
        const {
          default: PricingPage
        } = await import('./components/PricingPage')
          .catch(handleChunkLoadError);
        return PricingPage;
      },
      getData: ({ context: { props } }) => (props)
    }
  ]
});
